export function driverGigActivityQuery({ driverId, fleetCode, jwt, backEnd }) {
  return {
    back_end: backEnd,
    jwt,
    api_endpoint: "api3:portal:driver_desk",
    section: "gig_activity",
    request_type: "GET",
    driver_id: driverId,
    fleet_code: fleetCode,
  };
}
